import { omit, union, merge } from 'ramda'
import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.DOBOVO_APARTMENTS_FETCH_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_IMPORT_SUCCESS:
            const { apartments } = action.entities
            return {apartments: merge(state.apartments, apartments)}
        case ActionTypes.DOBOVO_APARTMENTS_SAVE_SUCCESS:
            return { ...state, apartments: { ...state.apartments, ...action.data.entities.apartments } }
        case ActionTypes.DOBOVO_APARTMENTS_DELETE_SUCCESS:
            return { apartments: omit([action.data], state.apartments) }
        case ActionTypes.DOBOVO_CURRENT_ORGANIZATION_CHANGE:
            return {}
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.DOBOVO_APARTMENTS_FETCH_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_IMPORT_SUCCESS:
            return union(state, action.result)
        case ActionTypes.DOBOVO_APARTMENTS_SAVE_SUCCESS:
            return union(state, [action.data.result])
        case ActionTypes.DOBOVO_APARTMENTS_DELETE_SUCCESS:
            return state.filter(item => item !== action.data)
        case ActionTypes.DOBOVO_CURRENT_ORGANIZATION_CHANGE:
            return []
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.DOBOVO_APARTMENTS_FETCH_REQUEST:
            return true
        case ActionTypes.DOBOVO_APARTMENTS_FETCH_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_FETCH_FAILURE:
        case ActionTypes.DOBOVO_APARTMENTS_SAVE_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_IMPORT_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_SAVE_FAILURE:
        case ActionTypes.DOBOVO_APARTMENTS_DELETE_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_DELETE_FAILURE:
        case ActionTypes.DOBOVO_APARTMENTS_IMPORT_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.DOBOVO_APARTMENTS_FETCH_FAILURE:
        case ActionTypes.DOBOVO_APARTMENTS_SAVE_FAILURE:
        case ActionTypes.DOBOVO_APARTMENTS_DELETE_FAILURE:
        case ActionTypes.DOBOVO_APARTMENTS_IMPORT_FAILURE:
            return action.error
        case ActionTypes.DOBOVO_APARTMENTS_FETCH_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_SAVE_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_DELETE_SUCCESS:
        case ActionTypes.DOBOVO_APARTMENTS_IMPORT_SUCCESS:
            return null
        default:
            return null
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/dobovoReducers/dobovoApartments.js